export default {
  title: {
    en: 'My Queue',
  },
  futurePurchases: {
    en: 'Future purchases',
  },
}
